goog.declareModuleId('yext.ui.components.entitypicker.entityicon');

import {EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';

export class EntityIcon {
  constructor(typeClass, itemClass, attributes) {
    this.typeClass = typeClass;
    this.itemClass = itemClass;
    this.typeAttributes = attributes;
    this.itemAttributes = attributes;
  }
}

const ENTITY_TYPE_TO_ICON = {
  0: new EntityIcon('type-LOCATION', 'icon-location', {}),
  1: new EntityIcon('type-HEALTHCARE_PROFESSIONAL', 'icon-person', {}),
  2: new EntityIcon('type-LOCATION', 'icon-location', {}),
  3: new EntityIcon('type-EVENT', 'icon-event', {}),
  4: new EntityIcon('type-LOCATION', 'icon-location', {}),
  5: new EntityIcon('type-LOCATION', 'icon-location', {}),
  6: new EntityIcon('type-ORGANIZATION', 'icon-location', {}),
  4000: new EntityIcon('type-HOTEL', 'icon-location', {}),
  4001: new EntityIcon('type-JOB', 'icon-location', {}),
  4002: new EntityIcon('type-FAQ', 'icon-location', {}),
  5700: new EntityIcon('type-HOTEL_ROOM_TYPE', 'icon-location', {}),
  29100: new EntityIcon('type-HELP_ARTICLE', 'icon-location', {}),
  29101: new EntityIcon('type-CONTACT_CARD', 'icon-location', {}),
  29102: new EntityIcon('type-BLOG_POST', 'icon-location', {}),
  29106: new EntityIcon('type-ORGANIZATION', 'icon-location', {}),
  29107: new EntityIcon('type-SITE', 'icon-location', {}),
  29108: new EntityIcon('type-PAGES_LAYOUT', 'icon-location', {}),
  29109: new EntityIcon('type-PAGES_THEME', 'icon-location', {}),
  29110: new EntityIcon('type-HEALTHCARE_PROVIDER', 'icon-location', {}),
  29111: new EntityIcon('type-PROVIDER_FACILITY', 'icon-location', {}),
  31640: new EntityIcon('type-FINANCIAL_PROFESSIONAL', 'icon-location', {}),
};

/**
 * @param {!EntityTypeModel} entityType
 * @returns {!EntityIcon}
 */
export function getEntityIcon(entityType) {
  if (entityType == null || !ENTITY_TYPE_TO_ICON.hasOwnProperty(entityType.id)) {
    const trimmedLabel = entityType?.label?.trimStart();
    const letter = entityType ? trimmedLabel[0] : '?';
    return new EntityIcon(
      'uep-icon-custom-entity-type',
      'uep-icon-custom-entity-item',
      {'data-custom-entity-first-letter': letter});
  } else {
    return ENTITY_TYPE_TO_ICON[entityType.id];
  }
}
